import { HeaderReflectionProps } from "../../../../components/header-reflection";
import { ParticipationHeaderProps } from "./../types";
import { ReflectionType } from "../../../../../../../types/domain-types";
import { useCountdownTimer } from "./../useCountdownTimer";
import { REFLECTION_TIMER_KEY } from "./../constants";
import { useReflectionData } from "./useReflectionData";
import { useItemizedList } from "./useItemizedList";
import {
  calculateQuestionProgress,
  calculateTopicProgressForReflection,
} from "../utils";
import { usePreviousValueWhileSaving } from "../usePreviousValueWhileSaving";

export function useReflectionHeaderProps(
  props: ParticipationHeaderProps
): HeaderReflectionProps {
  const { publicTest, currentSet, currentItemIndex, isSaving } = props;
  const isDynamicTestSet = !!currentSet.templateTestSetId;
  const { itemizedAverageScoreData, topic } = useReflectionData(props);
  const countdownTime = useCountdownTimer(REFLECTION_TIMER_KEY);

  const itemizedList = useItemizedList({
    itemizedAverageScoreData,
    reflectionType: currentSet.info.type as ReflectionType,
  });

  const { currentQuestion, totalQuestions } = calculateQuestionProgress(
    currentSet.items,
    currentItemIndex
  );

  const testSets = publicTest.reflectionTestSets.filter(ts =>
    isDynamicTestSet ? !!ts.templateTestSetId : !ts.templateTestSetId
  );

  // Find the index of the current test set
  const currentSetIndex = testSets.findIndex(ts => ts._id === currentSet._id);
  const uncompletedTestSetsCount =
    currentSetIndex >= 0 ? testSets.length - currentSetIndex : testSets.length;

  const { totalProgress, topicProgress } = calculateTopicProgressForReflection(
    testSets.length,
    uncompletedTestSetsCount,
    currentQuestion,
    totalQuestions
  );

  // Preserve the topicProgress value while saving to prevent UI flickering
  const effectiveTopicProgress = usePreviousValueWhileSaving(
    topicProgress,
    isSaving
  );

  return {
    totalProgress: isDynamicTestSet ? totalProgress : effectiveTopicProgress,
    topicProgress: isDynamicTestSet ? effectiveTopicProgress : 0,
    currentQuestion: isDynamicTestSet ? 0 : currentQuestion,
    totalQuestions: isDynamicTestSet ? 0 : totalQuestions,
    topic,
    countdownTime,
    itemizedList,
  };
}
